import {PROJECTS} from '../../actions/projects/projectsActionTypes';

const INITIAL_STATE = {
    projectsLoading: true,
    projectTypesLoading: true,
    projects: [],

    singleProject: {},
    singleProjectLoading: true,

    projectTypes: [],

    projectNotifications: {},
    projectNotificationsLoading: true,

    projectMembersList: [],
    projectMembersListLoading: true,

    projectEmployeesForAdding: [],
    projectEmployeesForAddingLoading: true,

    projectClientsForAdding: [],
    projectClientsForAddingLoading: true,

    projectEmployeesReview: [],
    projectEmployeesReviewLoading: true,

    projectChats: [],
    projectChatsLoading: true,

    projectChatsList: [],
    projectChatsListLoading: true,

    avatars: {
        list: [],
        loading: true
    },

    projectStatus : 'active',
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case PROJECTS.GET_PROJECTS_AVATARS_SUCCESS:
            return {...state, avatars: {list: action.payload.data.data, loading: false}};
        case PROJECTS.GET_PROJECTS_AVATARS_FAIL:
            return {...state, avatars: {list: [], loading: false}};
        case PROJECTS.GET_PROJECTS_AVATARS:
            return {...state, avatars: {...state.avatars, loading: true}};

        case PROJECTS.GET_PROJECTS_SUCCESS:
            const newProjects = action.payload.data.data;
            const needReload = action.payload.config?.reloadWithoutChats;

            if (needReload) {
                const updatedProjects = newProjects.map(newProj => {
                    const oldProj = state.projects.find(p => p.id === newProj.id);
                    return {
                        ...newProj,
                        messageCount: oldProj?.messageCount ?? newProj.messageCount,
                    };
                });

                return {
                    ...state,
                    projects: updatedProjects,
                    projectsLoading: false,
                };
            }

            return {
                ...state,
                projects: newProjects,
                projectsLoading: false,
            };        case PROJECTS.GET_PROJECTS_FAIL:
            return {...state, projectsLoading: false};
        case PROJECTS.GET_PROJECT_TYPES_SUCCESS:
            return {...state, projectTypes: action.payload.data.data, projectTypesLoading: false};
        case PROJECTS.GET_PROJECT_TYPES_FAIL:
            return {...state, projectTypes: [], projectTypesLoading: false};

        case PROJECTS.GET_PROJECT:
            if (action.payload?.request?.needReloadProjects) {
                return {...state, singleProjectLoading: true};
            }
            return {...state, singleProject: {}, singleProjectLoading: true};
        case PROJECTS.GET_PROJECT_SUCCESS:
            if (action.payload.config?.needReloadProjects) {
                return {
                    ...state,
                    singleProject: {
                        ...action.payload.data.data,
                        chats: state.singleProject.chats,
                    },
                    singleProjectLoading: false
                };
            }
            return {...state, singleProject: action.payload.data.data, singleProjectLoading: false};
        case PROJECTS.GET_PROJECT_FAIL:
            if (action?.error?.data === 'canceled') {
                return {...state, singleProject: {}, singleProjectLoading: true};
            }
            return {...state, singleProject: {}, singleProjectLoading: false};

        case PROJECTS.GET_PROJECT_MEMBERS_LIST_SUCCESS:
            return {...state, projectMembersList: action.payload.data.data, projectMembersListLoading: false};
        case PROJECTS.GET_PROJECT_MEMBERS_LIST_FAIL:
            return {...state, projectMembersList: [], projectMembersListLoading: false};

        case PROJECTS.GET_PROJECT_CHATS_SUCCESS:
            return {...state, projectChats: action.payload.data.data, projectChatsLoading: false};
        case PROJECTS.GET_PROJECT_CHATS_FAIL:
            return {...state, projectChats: {}, projectChatsLoading: false};
        case PROJECTS.GET_PROJECT_EMPLOYEES_FOR_ADDING_SUCCESS:
            return {
                ...state,
                projectEmployeesForAdding: action.payload.data.data,
                projectEmployeesForAddingLoading: false
            };
        case PROJECTS.GET_PROJECT_EMPLOYEES_FOR_ADDING_FAIL:
            return {...state, projectEmployeesForAdding: {}, projectEmployeesForAddingLoading: false};

        case PROJECTS.GET_PROJECT_CLIENTS_FOR_ADDING_SUCCESS:
            return {...state, projectClientsForAdding: action.payload.data.data, projectClientsForAddingLoading: false};
        case PROJECTS.GET_PROJECT_CLIENTS_FOR_ADDING_FAIL:
            return {...state, projectClientsForAdding: {}, projectClientsForAddingLoading: false};

        case PROJECTS.GET_PROJECT_REVIEW_EMPLOYEE_SUCCESS:
            return {...state, projectEmployeesReview: action.payload.data.data, projectEmployeesReviewLoading: false};
        case PROJECTS.GET_PROJECT_REVIEW_EMPLOYEE_FAIL:
            return {...state, projectEmployeesReview: {}, projectEmployeesReviewLoading: false};

        case PROJECTS.GET_PROJECTS_NOTIFICATIONS_SUCCESS:
            return {...state, projectNotifications: action.payload.data, projectNotificationsLoading: false};
        case PROJECTS.GET_PROJECTS_NOTIFICATIONS_FAIL:
            return {...state, projectNotifications: {}, projectNotificationsLoading: false};
        case PROJECTS.RESET_PROJECT_PARTICIPANTS:
            return {...state, projectMembersList: [], projectMembersListLoading: true};

        case PROJECTS.PROJECT_SET_FILTER_STATUS:
            return {...state, projectStatus: action.payload};

        case PROJECTS.UPDATE_COUNT_GENERAL: {
            const {id, count, type} = action.payload;

            return {
                ...state,
                projects: state.projects.map(project =>
                    project.id === id ? {
                        ...project,
                        messageCount: type === "plus" ? project.messageCount + count : Math.max(project.messageCount - count, 0),
                    } : project
                ),
            };
        }
        case PROJECTS.UPDATE_COUNT_IN_PROJECT: {
            const {id, count, type, onlyCountOld} = action.payload;

            return {
                ...state,
                singleProject: {
                    ...state.singleProject,
                    chats: state.singleProject.chats.map((chat) => {
                        if (chat.id === id) {
                            if (type === 'minusNew') {
                                return {
                                    ...chat,
                                    messageUnreadCount: Math.max(0, chat.messageUnreadCount - count),
                                }
                            }
                            if (onlyCountOld) {
                                return {
                                    ...chat,
                                    messageCount: type === 'plus' ? chat.messageCount + count : Math.max(0, chat.messageCount - count)
                                };
                            } else {
                                return {
                                    ...chat,
                                    messageUnreadCount: type === 'plus' ? chat.messageUnreadCount + count : Math.max(0, chat.messageUnreadCount - count),
                                    messageCount: type === 'plus' ? chat.messageCount + count : Math.max(0, chat.messageCount - count)
                                };
                            }
                        }
                        return chat;
                    })
                },
                projectChats: state.projectChats.map((chat) => {
                    if (chat.id === id) {
                        if (type === 'minusNew') {
                            return {
                                ...chat,
                                messageUnreadCount: Math.max(0, chat.messageUnreadCount - count),
                            }
                        } else if (onlyCountOld) {
                            return {
                                ...chat,
                                messageCount: type === 'plus' ? chat.messageCount + count : Math.max(0, chat.messageCount - count)
                            };
                        } else {
                            return {
                                ...chat,
                                messageUnreadCount: type === 'plus' ? chat.messageUnreadCount + count : Math.max(0, chat.messageUnreadCount - count),
                                messageCount: type === 'plus' ? chat.messageCount + count : Math.max(0, chat.messageCount - count)
                            };
                        }
                    }
                    return chat;
                })
            };
        }

        case PROJECTS.RESET_PROJECT:
            return {
                ...state,
                singleProject: {},
                singleProjectLoading: true,

                projectMembersList: [],
                projectMembersListLoading: true,

                projectEmployeesReview: [],
                projectEmployeesReviewLoading: true,

                projectChats: [],
                projectChatsLoading: true
            };
        default:
            return state;
    }
}
